export const WIDGET_PAGES = 'widget_pages';
export const BADGES = 'badges';
